/**
 * Armor of God coloring pages — authored via the `/pack` toile process (plan
 * `thinking/plans/2026_08_31_toile_pack_wiring.md` Track B), wave `toile_bible_stories`. Narcis file-split
 * shape (Track A): one module per pack, `registry.ts` assembles them into `livePacks`.
 */
import {tagline, chips, type ToilePack} from './data'

export const armorOfGodColoringPagesPack: ToilePack = {
    slug: 'armor-of-god-coloring-pages',
    category: 'faith',
    name: 'Armor of God coloring pages',
    tagline: tagline('pieces', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: {w: 832, h: 1216},
    readings: [
        {key: 'armor', label: 'Full armor', subject: 'a child standing tall in the whole armor of God, belt, breastplate, sturdy sandals, shield, helmet and sword'},
        {key: 'shield', label: 'Shield of faith', subject: 'a raised shield of faith stopping a volley of flaming arrows, the arrows going out as they strike it'},
        {key: 'sword', label: 'Helmet and sword', subject: 'the helmet of salvation and the sword of the Spirit laid crossed over an open Bible'},
    ],
    styles: [
        {key: 'bold', label: 'Bold and simple', style: 'bold thick-outline coloring book style, one heavy uniform black line, big simple open shapes for young children', palette: 'black ink only', framing: 'The drawing centered with a wide white margin on all sides'},
        {key: 'classic', label: 'Classic', style: 'classic coloring book line art, medium uniform black line, moderate detail and open shapes for ages six to nine', palette: 'black ink only', framing: 'The full page used, the drawing centered with a white margin'},
        {key: 'detailed', label: 'Fine detail', style: 'fine-line detailed coloring page, thin uniform black line, patterned robes, leaves and waves for older children', palette: 'black ink only', framing: 'The scene held inside a plain thin rectangular border with a white margin outside it'},
    ],
    directions: ['girl in armor', 'boy in armor', 'belt of truth'],
    directionHint: 'try: girl in armor',
    seo: {
        title: 'Armor of God Coloring Pages: Ephesians 6 in Three Pages',
        metaDescription: 'Nine armor of God coloring pages for Sunday school from Ephesians 6: the full armor, the shield of faith, and the helmet and sword, in three styles.',
        h1: 'Armor of God coloring pages: the full armor, shield of faith, helmet and sword',
        tagline: 'Nine pages of Ephesians 6 in three scenes, each in three line weights.',
        intro: 'Printable armor of God coloring pages for Sunday school and Christian homeschool, from Ephesians 6. Three pages: a child standing in the whole armor, a raised shield of faith stopping flaming arrows, and the helmet and sword of the Spirit laid over an open Bible. Bold, classic and fine-detail lines. Type a different figure or piece, and the same styles carry it.',
        useCases: [
            'a Sunday school lesson on Ephesians 6',
            "a children's church craft activity",
            'a Christian homeschool Bible unit',
            'a bulletin board on the armor of God',
        ],
        faq: [
            {q: 'Which pieces of armor do these show?', a: 'The full set: belt, breastplate, sandals, shield, helmet and sword.'},
            {q: 'Does a child appear in the armor?', a: 'Yes. The first page shows a child standing tall in the full armor.'},
            {q: 'Can I ask for a girl in armor or the belt of truth?', a: 'Yes. Type the figure or piece you want. The request shapes the page, but a result is not promised to match it exactly.'},
            {q: 'Are the pages in color?', a: 'No. Each page is black line on white, with open shapes to color in.'},
        ],
    },
}
